import script from "./SettingsItemSentiment.vue?vue&type=script&setup=true&lang=js"
export * from "./SettingsItemSentiment.vue?vue&type=script&setup=true&lang=js"

import "./SettingsItemSentiment.vue?vue&type=style&index=0&id=7e3edffe&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e3edffe"]])

export default __exports__